import React from 'react'
import './HorizontalStepper.css'
import CheckIcon from '../../media/felsv/CheckIcon.svg'

interface iPropsStepper {
  titles: Array<string>
  paginaActiva: number
}

const HorizontalStepperSecondary = ({titles, paginaActiva, ...props}: iPropsStepper) => {
  return (
    <div className='stepper-wrapper'>
      {titles.map((title, i) => (
        <div
          className={`s stepper-item${paginaActiva === i ? ' active' : ''}${
            i < paginaActiva ? ' completed' : ''
          }`}
          key={i}
        >
          <div className='step-counter'>
            <img src={CheckIcon} loading='lazy' alt='Emitir' />
          </div>
          <div className='step-name'>{title}</div>
        </div>
      ))}
    </div>
  )
}

export default HorizontalStepperSecondary
